import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import * as Middleware from "@middlewares/index";

interface PropsInterface {}

interface StateInterface {}

class Default extends React.Component<PropsInterface, StateInterface> {
  public render() {
    return (
      <>
        <div className="modal modal--netw-soon">
          <div className="modal__header">
            <div className="modal__title">Готовимся к старту!</div>
            <button
              className="modal__close"
              onClick={() => {
                Middleware.Ui.Modal.close();
              }}
            />
          </div>
          <div className="modal__body">
            <div className="modal__desc">
              Сервис будет доступен совсем скоро. Следите за обновлениями!
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(
    (Store: any) => {
      return { Store };
    },
    (Dispatch: any) => {
      return { Dispatch: (action: any) => Dispatch(action) };
    }
  )(Default)
);
